module.exports = __webpack_public_path__ + "static/media/gantt_placeholder.f637daae.png";